module.exports = __webpack_public_path__ + "static/media/services-bg-3.ebc452c9.avif";